export default __webpack_public_path__ + "static/Building Blocks-77f40be30e39f35b60a65b7b37c8344b.svg";